import { IQueryCommandOptions, convertQueryCommandToQueryString } from '@llws/dynamic-router-utils';
import { adminRequest } from '@/shared/request-configs/admin-request';

/**
 * Fetches Leads <br>
 * API Endpoint - `/leads-api/leads_readonly${query}` <br> via {@link adminRequest.get}
 * @param {IQueryCommandOptions} [filters] - optional filters string query
 */
export const get = async (filters?: IQueryCommandOptions) => {
  const query = filters ? convertQueryCommandToQueryString(filters) : '';
  return adminRequest.get(`/leads-api/leads_readonly${query}`);
};

/**
 * Fetches Combined Leads by ID <br>
 * API Endpoint - `/leads-api/leads_readonly/${id}` <br> via {@link adminRequest.get}
 * @param {number} id - id of combined leads
 */
export const getLeadsCombinedById = async (id: number) => adminRequest.get(
  `/leads-api/leads_readonly/${id}`,
);
/**
 * Fetches and Downloads Combined Leads in CSV <br>
 * API Endpoint - `/leads-api/leads_readonly${query}&exportCsv=true` <br> via {@link adminRequest.get}
 * @param {IQueryCommandOptions} [filters] - optional filters query string
 */
export const downloadLeadsCombined = (filters?: IQueryCommandOptions) => {
  const query = filters ? convertQueryCommandToQueryString(filters) : '';
  return adminRequest.get(`/leads-api/leads_readonly${query}&exportCsv=true`);
};

export default {
  get,
  getLeadsCombinedById,
  downloadLeadsCombined,
};
